import px2rem from '../../../utils/px2rem';

export const BASE_FONT_SIZE_NUMBER = 16;
export const BASE_FONT_SIZE = `${BASE_FONT_SIZE_NUMBER}px`;

const rem = (px: number) => px2rem(px, BASE_FONT_SIZE_NUMBER);

export const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700,
};

export const fontFamilyLato = [
  'Lato',
  '-apple-system',
  'BlinkMacSystemFont',
  'sans-serif',
];
export const fontFamilyRoboto = [
  'Roboto',
  '-apple-system',
  'BlinkMacSystemFont',
  'sans-serif',
];

export const fontFamilyLatoString = fontFamilyLato.join(',');
export const fontFamilyRobotoString = fontFamilyRoboto.join(',');

export const typography = {
  h1: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(101),
    fontWeight: fontWeights.light,
    letterSpacing: `-${rem(1.5)}`,
    lineHeight: rem(101),
  },
  h2: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(63),
    fontWeight: fontWeights.light,
    letterSpacing: `-${rem(0.5)}`,
    lineHeight: rem(63),
  },
  h3: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(50),
    fontWeight: fontWeights.regular,
    letterSpacing: `-${rem(0.5)}`,
    lineHeight: rem(54),
  },
  h4: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(36),
    fontWeight: fontWeights.regular,
    letterSpacing: `auto`,
    lineHeight: rem(38),
  },
  h5: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(25),
    fontWeight: fontWeights.regular,
    letterSpacing: `auto`,
    lineHeight: rem(32),
  },
  h6: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(21),
    fontWeight: fontWeights.bold,
    letterSpacing: `${rem(0.15)}`,
    lineHeight: rem(32),
  },
  subtitle1: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(17),
    fontWeight: fontWeights.regular,
    letterSpacing: `${rem(0.15)}`,
    lineHeight: rem(28),
  },
  subtitle2: {
    fontFamily: fontFamilyLatoString,
    fontSize: rem(15),
    fontWeight: fontWeights.regular,
    letterSpacing: `${rem(0.1)}`,
    lineHeight: rem(22),
  },
  body1: {
    fontSize: rem(16),
    fontWeight: fontWeights.regular,
    letterSpacing: `${rem(0.1)}`,
    lineHeight: rem(22),
  },
  body2: {
    fontSize: rem(14),
    fontWeight: fontWeights.regular,
    letterSpacing: `${rem(0.25)}`,
    lineHeight: rem(20.4),
  },
  button: {
    fontSize: rem(14),
    fontWeight: fontWeights.medium,
    lineHeight: rem(36),
    letterSpacing: `${rem(0.16)}`,
  },
  caption: {
    fontSize: rem(12),
    fontWeight: fontWeights.regular,
    letterSpacing: `${rem(0.4)}`,
    lineHeight: rem(20),
  },
  overline: {
    fontSize: rem(10),
    fontWeight: fontWeights.regular,
    letterSpacing: `${rem(1.5)}`,
    lineHeight: rem(30),
  },
};
